query TagTypesList(
  $page: Int = 0
  $rowsPerPage: Int = 10
  $filter: TagTypesFilterInput
) {
  tagTypes(page: $page, rowsPerPage: $rowsPerPage, filter: $filter) {
    nodes {
      id
      title
      featured
      seoDescription
      createdAt
    }
    count
  }
}
